module.exports = __webpack_public_path__ + "img/placard_m_05.a9091e98.png";